<div class="container">
  @if (name()) {
    <div class="header">
      <h4 class="header__name">{{ name() }}</h4>
    </div>
  }

  <ul class="tabs-list">
    @for (tab of tabs(); track $index) {
      <li class="tabs-list__item tab">
        <a
          class="tab__link"
          routerLinkActive="active"
          [routerLink]="tab.routerLink"
        >
          <div class="tab__link-content tab-content">
            <div class="tab-content__icon">
              <i class="icon" [ngClass]="tab.icon"></i>
            </div>

            <span class="tab-content__name">{{ tab.name }}</span>
          </div>

          <div class="tab__link-arrow">
            <i class="icon icon-chevron-right"></i>
          </div>
        </a>
      </li>
    }
  </ul>
</div>
